import { Collapse, Table } from "antd";
import moment from "moment";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { getUserLevel } from "../../helper/getUserLevel";
import { AnswerContext } from "../../store/answerStore";

const { Panel } = Collapse;
export default function TestSumTextMatch({ type }) {
  const { answerC, dispatchAnswer } = AnswerContext();

  let correct = 0;
  let inCorrect = 0;
  let attempted = 0;
  let unattempted = 0;

  answerC.answers[0].forEach((ansData) => {
    correct = ansData.correct ? correct + 1 : correct;
    inCorrect =
      !ansData.correct && ansData.userAns !== "" ? inCorrect + 1 : inCorrect;
    attempted = ansData.userAns !== "" ? attempted + 1 : attempted;
    unattempted = ansData.userAns === "" ? unattempted + 1 : unattempted;
  });

  const getCollapseHeader = (myCount) => {
    let Ccorrect = 0;
    let CinCorrect = 0;
    let Cattempted = 0;
    let Cunattempted = 0;

    answerC.answers[0].forEach((ansData) => {
      if (ansData.letter_count === myCount) {
        Ccorrect = ansData.correct ? Ccorrect + 1 : Ccorrect;
        CinCorrect =
          !ansData.correct && ansData.userAns !== ""
            ? CinCorrect + 1
            : CinCorrect;
        Cattempted = ansData.userAns !== "" ? Cattempted + 1 : Cattempted;
        Cunattempted = ansData.userAns === "" ? Cunattempted + 1 : Cunattempted;
      }
    });

    return {
      total: Cattempted + Cunattempted,
      Ccorrect,
      CinCorrect,
      Cattempted,
      Cunattempted,
    };
  };

  const chartData = {
    showTooltips: true,
    maintainAspectRatio: false,
    responsive: false,
    labels: [
      `${correct} Correct`,
      `${inCorrect} Incorrect`,
      `${unattempted} Unattempted`,
    ],
    datasets: [
      {
        data: [correct, inCorrect, unattempted],
        backgroundColor: ["#2B72FE", "#FFC700", "#D32976"],
      },
    ],
  };

  const chartOptions = {
    legend: {
      // display: false,
      position: "right",
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
  };

  const panelHeader = (count) => {
    return (
      <div className="text-match-panel">
        <div className="text-match-scoring total">
          <p>TOTAL</p>
          <h3>{getCollapseHeader(count).total}</h3>
        </div>
        <div className="text-match-scoring">
          <p>Correct</p>
          <h3>{getCollapseHeader(count).Ccorrect}</h3>
        </div>
        <div className="text-match-scoring">
          <p>Incorrect</p>
          <h3>{getCollapseHeader(count).CinCorrect}</h3>
        </div>
        <div className="text-match-scoring">
          <p>Unattempted</p>
          <h3>{getCollapseHeader(count).Cunattempted}</h3>
        </div>
      </div>
    );
  };

  const getLetterCount = (myCount) => {
    let meQue = [];
    answerC.answers[0].forEach((ansData) => {
      console.log(ansData);
      if (ansData.letter_count === myCount) {
        meQue = [...meQue, ansData];
      }
    });

    const getTheChoice = (ansedQues, choice) => {
      const choiceArr = choice.split(",");
      const choice1 = ansedQues[`choice_${choiceArr[0]}`];
      const choice2 = ansedQues[`choice_${choiceArr[1]}`];
      return `${choice1} ${!!choice2 ? "," : ""} ${!!choice2 ? choice2 : ""}`;
    };

    const textData = meQue.map((myAns, index) => {
      return {
        key: index,
        sno: <h4 style={{ margin: 0 }}>Q{index + 1}</h4>,
        correctAnswer: getTheChoice(myAns, myAns.correct_choice),
        userAnswer: !!myAns.userAns ? getTheChoice(myAns, myAns.userAns) : "NA",
        score: myAns.userAns === myAns.correct_choice ? 1 : 0,
      };
    });

    const textColumn = [
      {
        title: "",
        dataIndex: "sno",
        key: "sno",
        align: "center",
      },
      {
        title: "Correct Answer",
        dataIndex: "correctAnswer",
        key: "correctAnswer",
        align: "center",
      },
      {
        title: "User Answer",
        dataIndex: "userAnswer",
        key: "userAnswer",
        align: "center",
      },
      {
        title: "Score",
        dataIndex: "score",
        key: "score",
        align: "center",
      },
    ];

    return (
      <>
        <Table
          scroll={{ y: 135 }}
          pagination={false}
          dataSource={textData}
          columns={textColumn}
        />
      </>
    );
  };

  return (
    <div className="text-match-sum-page">
      <div className="text-match-heading">
        <div className="date">
          <h3>Date: {moment().format("DD-MMM-YYYY")}</h3>
        </div>
        <div className="head">
          <h1>TEXT MATCH - {getUserLevel()}</h1>
        </div>
        <div className="score">
          <h3>
            Total Score <span>{correct}</span>
          </h3>
        </div>
      </div>
      <div className="text-match-chart">
        <Doughnut data={chartData} options={chartOptions} />
      </div>
      <div className="letter-count-scoring">
        {["1", "2", "3", "4", "5"].map((count) => {
          return (
            <>
              <h4 className="letter-count">{count} LETTER TYPE</h4>
              <Collapse
                onChange={(e) => {
                  console.log(e);
                }}
                className="text-match-collapse"
                expandIconPosition={"right"}
              >
                <Panel header={panelHeader(count)} key="1">
                  {/* All ans {data}  */}
                  {getLetterCount(count)}
                </Panel>
              </Collapse>
            </>
          );
        })}
      </div>
    </div>
  );
}
